export default __webpack_public_path__ + "static/media/8d021446809c342df960c301399d9525.svg";